'use client'

import { useTranslations } from 'next-intl'

import { Select, SelectContent, SelectItem, SelectTrigger } from '@/components/ui/select'
import { TIME_FRAME_OPTIONS } from '@/features/chart/lib/utils/chart-util'

interface IntervalSelectorProps {
  timeframe: number
  onTimeframeChange: (timeframe: number) => void
  hideLabel?: boolean
}

export default function IntervalSelector({
  timeframe,
  onTimeframeChange,
  hideLabel,
}: IntervalSelectorProps) {
  const t = useTranslations('trade.chartToolbar')
  const selectedTimeFrame = TIME_FRAME_OPTIONS.find((option) => option.value === timeframe)

  const onClickTimeFrame = (value: string) => {
    onTimeframeChange(Number(value))
  }

  return (
    <Select value={selectedTimeFrame?.value.toString() ?? ''} onValueChange={onClickTimeFrame}>
      <SelectTrigger
        asChild
        className="hover:bg-foreground/5 data-[state=open]:bg-foreground/5 h-6 border-none bg-transparent p-0 px-2 data-[state=open]:rounded-b-none"
      >
        <div className="text-foreground/60 flex cursor-pointer items-center gap-1.5 text-xs tracking-tight">
          {!hideLabel && t('intervalLabel')}
          <p className="text-foreground">
            {selectedTimeFrame ? t(`timeframes.${selectedTimeFrame.label}`) : ''}
          </p>
        </div>
      </SelectTrigger>
      <SelectContent className="min-w-25 data-[side=bottom]:-translate-y-px data-[side=top]:translate-y-px data-[state=open]:data-[side=bottom]:rounded-t-none data-[state=open]:data-[side=top]:rounded-b-none">
        {TIME_FRAME_OPTIONS.map((option) => (
          <SelectItem
            key={option.value}
            value={option.value.toString()}
            className="text-foreground max-w-25 text-xs tracking-tight"
          >
            {t(`timeframes.${option.label}`)}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
